import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { App } from "./App";
import { BrowserRouter } from 'react-router-dom';
import { HttpServiceProvider } from './services/context/HttpServiceContext';

ReactDOM.render(
  <HttpServiceProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HttpServiceProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
